// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"351af3e9","455":"ef89ef4a","977":"749cf3a7"}[chunkId] + ".chunk.js";
};